import {
  Button,
  Flex,
  Typography,
  useMobileMediaQuery,
} from '@iheartjane/reefer';

import type { FilterItemProps } from '@jane/search/data-access';
import { formatCount } from '@jane/search/util';
import { truncateLabel } from '@jane/shared-ecomm/util';

import { useActiveFilterContext } from './activeFilterProvider';

export const FilterButton = ({
  filterKey,
  hideCounts,
  item,
  onChange,
  ariaLabel,
}: FilterItemProps) => {
  const { label, icon, count, value, key } = item;
  const isMobile = useMobileMediaQuery({});
  const { activeFilters } = useActiveFilterContext();

  const labelLength = isMobile ? 20 : 40;

  const itemCount = !hideCounts ? ` (${formatCount(count)})` : '';

  const renderedLabel = `${truncateLabel(label, labelLength)}${itemCount}`;

  // prevents the icon from shrinking
  const iconToRender = <Flex data-testid="filter-button-icon">{icon}</Flex>;

  const isSelected = activeFilters.some((filter) => filter.value === value);

  return (
    <Button
      key={label}
      label={
        <Typography
          variant="body-semibold"
          maxLines={2}
          overflowWrap="anywhere"
        >
          {renderedLabel}
        </Typography>
      }
      aria-label={ariaLabel}
      aria-pressed={isSelected}
      startIcon={icon ? iconToRender : undefined}
      onClick={() => onChange(key || filterKey, value)}
      variant={isSelected ? 'tertiary-selected' : 'tertiary'}
      alignment="left"
      size="large"
      full
      disabled={!count}
    />
  );
};
